// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"995b1359","671":"8ddb7406","848":"90df3581"}[chunkId] + ".chunk.js";
};